module.exports = __webpack_public_path__ + "img/createtrackingnumber.fd67cfb5.png";